<template>
  <div style="backgrop">
    {{ $t("message.welcome") }}
    <!-- <el-row :gutter="20">
            <el-col :span="8">
                <div class="grid-top bg-user">
                    <h3>新增会员</h3>
                    <h2>{{memebers}}</h2>
                    <h3>{{memberRate}}</h3>
                </div>
    
            </el-col>
            <el-col :span="8">
                <div class="grid-top bg-activity">
                    <h3>活动浏览人数</h3>
                    <h2>{{viewers}}</h2>
                    <h3></h3>
                </div>
    
            </el-col>
            <el-col :span="8">
                <div class="grid-top bg-checkIn">
                    <h3>签到人数</h3>
                    <h2>{{checkIn}}</h2>
                    <h3>{{checkInRate}}</h3>
                </div>
    
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex">
            <el-col :span="8">
                <div class="grid-content">
                    <el-card header="今日课程" class="card" :body-style="{padding:'10px'}">
                        <today-course/>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content">
                    <el-card header="最新活动" class="card" :body-style="{padding:'10px'}">
                        <latest-activity/>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content">
                    <el-card header="" class="card" :body-style="{padding:'10px'}">
                    </el-card>
                </div>
            </el-col>
        </el-row>-->
  </div>
</template>

<script>
import services from "@/services";
import LatestActivity from "@/components/activity/LatestActivity";
import TodayCourse from "@/components/course/TodayCourse";

export default {
  data() {
    return {
      memebers: 0,
      memberRate: "0%",
      viewers: 0,
      checkIn: 0,
      checkInRate: "0%",
    };
  },
  created: function () {
    //this.fetchData()
  },
  methods: {
    fetchData() {
      let that = this;
      services.api.dashboard.report({}).then(function (response) {
        if (response.data.success) {
          that.memebers = response.data.result.memebers;
          that.memberRate = response.data.result.memberRate;
          that.viewers = response.data.result.viewers;
          that.checkIn = response.data.result.checkIn;
          that.checkInRate = response.data.result.checkInRate;
        }
      });
    },
  },
  components: {
    LatestActivity,
    TodayCourse,
  },
};
</script>

<style scoped>
.grid-top {
  height: 100px;
  padding: 10px;
  background: white;
  color: white;
  margin-bottom: 20px;
}

.grid-top h2 {
  line-height: 40px;
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  font-weight: normal;
}

.grid-top h3 {
  line-height: 30px;
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  font-weight: normal;
}

.bg-user {
  background: #10cfbd;
  background-image: url(../../assets/icons/member_bg.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}

.bg-activity {
  background: #48b0f7;
  background-image: url(../../assets/icons/activity_bg.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}

.bg-checkIn {
  background: #6d5cae;
  background-image: url(../../assets/icons/reservation_bg.png);
  background-repeat: no-repeat;
  background-position: right bottom;
}

.grid-content,
.grid-content .card {
  display: block;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?1f9f3dd8